import { SafeNavigateProvider } from './safe-navigate';
import { NavigationHistoryProvider } from './navigation-history';

export * from './routes';
export * from './generate-path';
export * from './match-route';
export * from './path-params';

type RouterProviderProps = { children: React.ReactNode };

export function RouterProvider({ children }: RouterProviderProps) {
  return (
    <SafeNavigateProvider>
      <NavigationHistoryProvider>{children}</NavigationHistoryProvider>
    </SafeNavigateProvider>
  );
}
